import type { TimestampedEntry } from '@/modules/viewer/types/logs';

// Re-export UI type shorthands so components that pull utilities from here
// don't also need a separate import from types/logs.
export type { ConsoleFilter, NetworkFilter, LogSubTab, LogsLoadStatus } from '@/modules/viewer/types/logs';

/**
 * Compute the id of the nearest-past entry for a given currentTime.
 * Used for the auto-scroll highlight. Entries must be sorted by timestamp asc.
 */
export const findActiveEntryId = (entries: TimestampedEntry[], currentTime: number): string | null => {
  let activeId: string | null = null;
  for (const entry of entries) {
    if (entry.timestamp <= currentTime) {
      activeId = entry.id;
    } else {
      break;
    }
  }
  return activeId;
};
